<template>
  <div id="user-list">
    <departamento-list-add-new
      v-model="isAddNewDepartamentoSidebarActive"
      @refetch-data="getDepartamento"
    />

    <contadores
      :total="total"
      :ativos="ativos"
    />

    <v-card>
      <v-card-title> Filtrar </v-card-title>
      <v-row class="px-2 ma-0">
        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model.trim="filtros"
            placeholder="Selecionar por Status"
            :items="opcoes"
            item-text="title"
            item-value="value"
            outlined
            dense
            clearable
            hide-details
            @change="getDepartamento"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-4"></v-divider>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getDepartamento"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            v-if="!acessoPost"
            color="primary"
            class="mb-4 me-3"
            disabled
            @click.stop="isAddNewDepartamentoSidebarActive = !isAddNewDepartamentoSidebarActive"
          >
            <v-icon>{{ icons.mdiPlus }}</v-icon>
            <span>Criar</span>
          </v-btn>

          <v-btn
            v-else
            color="primary"
            class="mb-4 px-4"
            @click.stop="isAddNewDepartamentoSidebarActive = !isAddNewDepartamentoSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-departamento
          :items="departamentos"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getDepartamento"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from '@/views/departamento/Contadores.vue'
import TableDepartamento from '@/components/tables/TableDepartamento.vue'
import DepartamentoListAddNew from './DepartamentoListAddNew.vue'
import DepartamentoService from '@/services/modules/DepartamentoService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    DepartamentoListAddNew,
    TableDepartamento,
    Contadores,
  },

  setup() {
    const isAddNewDepartamentoSidebarActive = ref(false)

    const { funcionalidades } = storeToRefs(useAuthStore())

    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
      { title: 'Todos', value: '' },
    ]

    const departamentos = ref([])
    const total = ref([])
    const ativos = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('')
    const idPost = 1012
    const idDisable = 1014
    const acessoPost = ref(true)
    const acessoDisable = ref(true)
    const pagina = ref(1)
    const itensPorPagina = ref(10)

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    async function getDepartamento() {
      loading.value = true
      try {
        const data = await DepartamentoService.get()

        departamentos.value = data
        total.value = departamentos.value
        ativos.value = departamentos.value.filter(d => d.ativo)

        if (search.value) {
          departamentos.value = departamentos.value.filter(d => d.nome.toLowerCase().includes(search.value.toLowerCase())
          || d.descricao.toLowerCase().includes(search.value.toLowerCase()))
        }

        departamentos.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))
      } catch {
      // tratamento erro simples
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      getDepartamento()
      // permissoes()
    })

    return {
      pagina,
      itensPorPagina,
      isAddNewDepartamentoSidebarActive,
      opcoes,
      departamentos,
      total,
      ativos,
      loading,
      search,
      filtros,
      acessoPost,
      acessoDisable,
      getDepartamento,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
